/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import footballField from "../Images/Field2.png";
import './MyTeam.css';
import CurrentUserContext from "../../Contexts/userContexts";
import FieldPlayers from "../PlayerList/FootballFieldPlayers";
import FieldInfo from "../PlayerList/FootballFieldInfo"
import Avatar from '../Images/kindpng_248549.png';


const MyTeam = () => {
    const { goalkeeper, setGoalkeeper, defender, setDefender, midfielder, setMidfielder, forward, setForward } = useContext(CurrentUserContext);
    const [forwardInfo, setForwardInfo] = useState([])
    const [midfielderInfo, setMidfielderInfo] = useState([])
    const [defenderInfo, setDefenderInfo] = useState([])
    const [goalkeeperInfo, setGoalkeeperInfo] = useState([])

    let defaultForward = [{ strPlayer: "Player", strCutout: Avatar, strTeam: "Team" },
    { strPlayer: "Player", strCutout: Avatar, strTeam: "Team" }];

    let defaultMidfielder = [{ strPlayer: "Player", strCutout: Avatar, strTeam: "Team" },
    { strPlayer: "Player", strCutout: Avatar, strTeam: "Team" },
    { strPlayer: "Player", strCutout: Avatar, strTeam: "Team" },
    { strPlayer: "Player", strCutout: Avatar, strTeam: "Team" }];

    let defaultDefender = [{ strPlayer: "Player", strCutout: Avatar, strTeam: "Team" },
    { strPlayer: "Player", strCutout: Avatar, strTeam: "Team" },
    { strPlayer: "Player", strCutout: Avatar, strTeam: "Team" },
    { strPlayer: "Player", strCutout: Avatar, strTeam: "Team" }];

    let defaultGoalkeeper = [{ strPlayer: "Player", strCutout: Avatar, strTeam: "Team" }]





    const onClickClear = () => {
        localStorage.clear();
        setGoalkeeper([]);
        setDefender([]);
        setMidfielder([]);
        setForward([]);
    }




    useEffect(() => {
        replaceForwards()
        replaceMidfielder()
        replaceDefenders()
        replaceGoalkeeper()
    }, [forward, midfielder, defender, goalkeeper])


    function replaceForwards() {
        let index = 0;
        setForwardInfo(defaultForward)
        while (index < forward.length) {
            if (defaultForward[index].strPlayer === "Player") {
                defaultForward[index] = forward[index]
            } index++
            setForwardInfo(defaultForward)
        }

    }

    const displayForwardInfo = forwardInfo.map(def =>
        <FieldInfo {...def} key={def.idPlayer} />)


    function replaceMidfielder() {
        setMidfielderInfo(defaultMidfielder)
        let index = 0;
        while (index < midfielder.length) {
            if (defaultMidfielder[index].strPlayer === "Player") {
                defaultMidfielder[index] = midfielder[index]
            } index++
            setMidfielderInfo(defaultMidfielder)
        }

    }


    const displayMidfielderInfo = midfielderInfo.map(def =>
        <FieldInfo {...def} key={def.idPlayer} />)


    function replaceDefenders() {
        setDefenderInfo(defaultDefender)
        let index = 0;
        while (index < defender.length) {
            console.log(index)
            if (defaultDefender[index].strPlayer === "Player") {
                defaultDefender[index] = defender[index]
            } index++
            setDefenderInfo(defaultDefender)
        }

    }
    const displayDefenderInfo = defenderInfo.map(def =>
        <FieldInfo {...def} key={def.idPlayer} />)

    function replaceGoalkeeper() {
        let index = 0;
        setGoalkeeperInfo(defaultGoalkeeper)
        while (index < goalkeeper.length) {
            console.log(index)
            if (defaultGoalkeeper[index].strPlayer === "Player") {
                defaultGoalkeeper[index] = goalkeeper[index]
            } index++
            setGoalkeeperInfo(defaultGoalkeeper)
        }

    }
    const displayGoalkeeperInfo = goalkeeperInfo.map(def =>
        <FieldInfo {...def} key={def.idPlayer} />)







    return (
        <div className="container">
            < div className="myPlayerInformationBox">
                <div className="sideInformation">
                    <h1>My Forwards</h1>
                    <div className="TeamPlayerInfoForward">
                        {displayForwardInfo}
                    </div>
                </div>
                <div className="sideInformation">
                    <h1>My Midfields</h1>
                    <div className="TeamPlayerInfo">
                        {displayMidfielderInfo}
                    </div>
                </div>
                <div className="sideInformation">
                    <h1>My Defenders</h1>
                    <div className="TeamPlayerInfo">
                        {displayDefenderInfo}

                    </div>
                </div>
                <div className="sideInformation">
                    <h1>My Goalkeeper</h1>
                    <div className="TeamPlayerInfoGoalkeeper">
                        {displayGoalkeeperInfo}
                    </div>
                </div>
            </div>
            <div className="football-container">

                <div className="fieldImage" style={{
                    gridRow: "1/span 2",
                    gridColumn: "1/span 2", width: "100%"
                }}><img className="footBallImag" src={footballField} alt="footballField" /></div>
                <div className="footBallGrid">
                    <div className="item1">{forward.map(el => <FieldPlayers {...el} key={el.idPlayer} />)}</div>
                    <div className="item2">{midfielder.map(el => <FieldPlayers {...el} key={el.idPlayer} />)}</div>
                    <div className="item3">{defender.map(el => <FieldPlayers {...el} key={el.idPlayer} />)}</div>
                    <div className="item4">{goalkeeper.map(el => <FieldPlayers {...el} key={el.idPlayer} />)}</div>
                </div>
            </div>
            <div className="button">
                <button onClick={onClickClear} className="clearPlayers">
                    Delete Players
                </button>
            </div>
        </div>
    )
}


export default MyTeam;